export const API_URL = process.env.REACT_APP_API_DEV_URL as string;
export const API_DEV_URL = process.env.REACT_APP_API_DEV_URL as string;

export const JWT_SECRET = '123456' as string;
